// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5662":"css/admin-app.6737","7309":"css/app.6737"}[chunkId] + ".css";
};